<template>
  <v-main>
    <v-container>
      <v-row class="d-flex justify-center">
        <h1>{{ $t('Datos de la cita') }}</h1>
      </v-row>
<!--      <v-row>-->
<!--        <v-col class="d-flex justify-end">-->
<!--          <h1>{{ $t('Código de reserva') }}</h1>-->
<!--        </v-col>-->
<!--        <v-col class="d-flex align-center">-->
<!--          test-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-row>
        <v-col class="d-flex justify-end">
          <h1>{{ $t('Cliente') }}</h1>
        </v-col>
        <v-col class="d-flex align-center" style="font-size: x-large">
          {{ cita.cliente_obj.nombre }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-end">
          <h1>{{ $t('Centro') }}</h1>
        </v-col>
        <v-col class="d-flex align-center" style="font-size: x-large">
          {{ cita.centro_obj.nombre }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-end">
          <h1>{{ $t('Servicios') }}</h1>
        </v-col>
        <v-col class="d-flex align-center">
          <ul v-for="(servicio, i) in cita.servicios_obj" :key="i" style="font-size: x-large">
            <li>
              {{ servicio.nombre }}
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-end">
          <h1>{{ $t('Fecha') }}</h1>
        </v-col>
        <v-col class="d-flex align-center" style="font-size: x-large">
          {{ cita.fecha }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-end">
          <h1>{{ $t('Hora') }}</h1>
        </v-col>
        <v-col class="d-flex align-center" style="font-size: x-large">
          {{ cita.hora_inicio }}
        </v-col>
      </v-row>
      <v-row>
        <v-btn class="white--text" color="red" block :disabled="!cita_pendiente" @click="cancelar_cita">
          {{ $t('Cancelar cita') }}
        </v-btn>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "CancelarCita",

  data: () => ({
    cita: {},
    cliente: {}
  }),

  async mounted() {
    $zopim(() => {
      $zopim.livechat.hideAll()
    })
    await this.get_cita()
  },

  methods: {
    async get_cita() {
      this.cita = await this.$store.dispatch("cita/get_cita_api", this.$route.params.cita)
    },

    async cancelar_cita() {
      try {
        await this.$store.dispatch("cita/cancelar_cita", this.cita.id)
        this.$snotify.success(
          this.$t("Cita cancelada correctamente")
        )
        await this.get_cita()
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error al cancelar la cita")
        )
      }
    }
  },

  computed: {
    cita_pendiente() {
      return this.cita.estado === 2
    }
  }
}
</script>

<style scoped>

</style>
